import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { HUD } from "./hud/HUD";
import { AudioManager } from "../../AudioManager";

export class CoinsEffect extends Phaser.GameObjects.Container {

    private coins: {coin: Phaser.GameObjects.Image, f: number, levitatingSpeed: number, smoothFactor: number}[];
    private f: number;
    private endPx: number;
    private endPy: number;
    private areCoinsCloseToEndPosition: boolean;
   
    constructor(scene: Phaser.Scene, x: number, y: number, value: number) {

        super(scene);

        this.f = 0;
        this.endPx = GameConstants.GAME_WIDTH * .5 + 35;
        this.endPy = 32 * GameVars.scaleY;
        this.areCoinsCloseToEndPosition = false;
        this.coins = [];

        let n: number;

        if (value <= 10) {
            n = 4;
        } else if (value <= 15) {
            n = 6;
        } else if (value <= 20) {
            n = 8;
        } else {
            n = 12;
        }

        for (let i = 0; i < n; i ++) {

            const coin = new Phaser.GameObjects.Image(this.scene, x + 12 - 24 * Math.random(), y + 20 - 30 * Math.random(), "texture_atlas_1", "coin");
            coin.scaleY = GameVars.scaleY;
            coin.setScale(0);
            this.add(coin);

            this.coins.push({coin: coin, f: 30 + Math.floor(35 * Math.random()), levitatingSpeed: .3 + .5 * Math.random(), smoothFactor: .01 + .0125 * Math.random()});
        }

        AudioManager.playSoundEffect("coins_emitted");

        this.scene.sys.updateList.add(this);
    }

    public preUpdate(time: number, delta: number): void {

        this.f ++;

        let sumDistances = 0;
      
        for (let i = 0; i < this.coins.length; i ++) {

            const coin = this.coins[i].coin;
            const framesLevitating = this.coins[i].f;
            const levitatingSpeed = this.coins[i].levitatingSpeed;

            if (this.f < framesLevitating) {

                if (i % 2 === 0) {
                    coin.x += levitatingSpeed;
                } else {
                    coin.x -= levitatingSpeed;
                }

                coin.y -= levitatingSpeed * .5 * GameVars.scaleY;

                let s = coin.scaleX;
                
                if (s < 1) {
                    s += .075;
                } 

                coin.setScale(s, s * GameVars.scaleY);

            } else {
                
                const smoothFactor = this.coins[i].smoothFactor;

                this.coins[i].smoothFactor *= 1.05;

                const dx = (this.endPx - coin.x) * smoothFactor;
                const dy = (this.endPy - coin.y) * smoothFactor;

                sumDistances += (Math.abs(this.endPx - coin.x) + Math.abs(this.endPy - coin.y));
        
                coin.x += dx;
                coin.y += dy;

                coin.alpha *= .975;
            }
        }   

        if (this.f > 50 && sumDistances < 50 && !this.areCoinsCloseToEndPosition) {

            this.areCoinsCloseToEndPosition = true;
            HUD.currentInstance.onCoinsReachedEndPosition();
            AudioManager.playSoundEffect("coins_collected");
        }

        if (this.f > 50 && sumDistances < 2.5 ) {
            this.destroy();  
        }
    }
}
